import { useContext, useEffect, useState } from "react";
import SPTemplate from "../templates/SPTemplate";
import { Box, Button, colors, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";


import * as BL_kintai from '../BL/BL_kintai';
import * as BL_approval from '../BL/BL_approval';
import * as commonFnc from '../common/commonFnc';
import {GlobalContext} from '../globalState'


import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { borderRadius, fontSize, height, minWidth, width } from "@mui/system";

import { Kintai_overtime } from "../classes/Kintai_overtime_class";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ChangeShiftPriorityHighIcon from "../conponents/parts/ChangeShiftPriorityHighIcon";
import isNextDate from "../util/isNextDate";

const styles = {
  table:{
    height:'78vh',
    overflow:'auto',
  },
  calHeader:{
    backgroundColor:'snow',
    display:'flex'
  },
  calHeaderMonth:{
    width:'80%',
    textAlign:'center',
    fontSize:'1.4rem'
  },
  calHeaderButton:{
    width:'10%'
  },
  calcell:{
    textAlign:'center',
    padding:'2px',
    fontSize:'0.65rem',
  },
  calButton:{
    backgroundColor:'snow',
    padding:'3px',
    minWidth:'40px',
    margin:'0px',
    fontSize:'0.7rem',
  },
  calButtonCancel:{
    backgroundColor: colors.lightGreen[400],
    color:'snow',
  },
  calButtonDisabled:{
    backgroundColor: colors.grey[400],
    color:'snow',
  },
  calShift:{
    margin:'0 auto',  
    textAlign:'center',
    whiteSpace: 'nowrap',
    overflow:'hidden', 
    width:'100%',
    borderRadius:'5px',
  },
  calHelperText:{
    color:'gray'
  }

}

const SP_KintaiListPage = (props) =>{
  const {
      Login_user_info, 
      display_user_info,
      setDisplay_user_info, 
      login_user_id, 
      setLogin_user_id,

      setShiftStartDay,

      setLogin_user_info,
      setKintai_bscs, 
      Kintai_bscs, 
      Kintai_bsc, 
      setKintai_bsc, 
      Shift_msts, 
      shiftStartDay, 
      Department_msts, 
      setRequest_overtimes,
      setRequest_paid_holiday, 
      Users
  } = props;

  const history = useHistory();
  const shift_group_cd_hash = useContext(GlobalContext).shift_group_cd;

  // 差し戻し等のエラーメッセージがあるかどうか
  const [isAlert, setIsAlert] = useState(false);

  
  const Env_msts = useContext(GlobalContext).Env_msts;
  const custom1 = Env_msts.find(p=>p.env_key==="CUSTOM1");
  const custom2 = Env_msts.find(p=>p.env_key==="CUSTOM2");
  const custom3 = Env_msts.find(p=>p.env_key==="CUSTOM3");
  const custom4 = Env_msts.find(p=>p.env_key==="CUSTOM4");
  const custom5 = Env_msts.find(p=>p.env_key==="CUSTOM5");

  // シフト名称のハッシュ
  var shiftHash = {};
  Shift_msts.map((Shift_mst) => (
      shiftHash[Shift_mst.shift_type_cd] = Shift_mst.shift_name
  ));

  // シフトの色のハッシュ
  var shiftColorHash = {};
  Shift_msts.map((Shift_mst) => (
      shiftColorHash[Shift_mst.shift_type_cd] = {
          backgroundcolor: Shift_mst.backgroundcolor?Shift_mst.backgroundcolor:'lightgray',
          textcolor: Shift_mst.textcolor
      }
  ));

  // 打刻情報
  const [clockin_jarnals_atMonth_atUser, setClockin_jarnals_atMonth_atUser] = useState([]);

  // 表示用の勤怠情報：打刻情報を含む1カ月のカレンダー形式
  const [Kintai_bscs_view, setKintai_bscs_view] = useState([]);
  
  // 祝日情報
  const [holidays, setHolidays] = useState({})
  useEffect(()=>{
      fetch('https://holidays-jp.github.io/api/v1/date.json')
      .then((res) => res.json())
      .then((data)=>setHolidays(data));
  },[])

  // 打刻情報と勤怠情報を再取得
  useEffect(()=>{

    getClockinJarnals();
    getKintaiBscs();

  },[shiftStartDay, display_user_info]);

  // 勤怠情報の再取得
  const getKintaiBscs = async () =>{
    if(display_user_info){
        const query = new URLSearchParams({login_user_id: display_user_info.user_id});
        const res = await fetch(`/api/select/kintai_bsc?${query}`);
        const data = await res.json();
        setKintai_bscs(data);
    }
  }

  // 打刻情報の再取得
  const getClockinJarnals = async () =>{
    
    var tmpDay = new Date(shiftStartDay);
    let shiftEndDay = tmpDay.setMonth(tmpDay.getMonth() + 1);

    const query_clockin = new URLSearchParams({target_user_id: display_user_info?.user_id, target_date_from: commonFnc.formatDate(shiftStartDay), target_date_to:commonFnc.formatDate(shiftEndDay)});
    let res_clockin = await fetch(`/api/select/clockin_jarnals_atMonth_atUser?${query_clockin}`);
    let data_clockin = await res_clockin.json();
    setClockin_jarnals_atMonth_atUser(data_clockin);
  }

  // カレンダーの再作成
  useEffect(()=>{
    var days = commonFnc.getCalendar(new Date(shiftStartDay));
    setKintai_bscs_view(commonFnc.createCalender(days, Kintai_bscs, clockin_jarnals_atMonth_atUser, display_user_info?.user_id));
  },[clockin_jarnals_atMonth_atUser,Kintai_bscs])

  useEffect(()=>{
    const dayBeforeMonth = new Date(shiftStartDay);
    dayBeforeMonth.setMonth(dayBeforeMonth.getMonth() - 1);

    const shiftEndDay = new Date(
      new Date(shiftStartDay).getFullYear(),
      new Date(shiftStartDay).getMonth() + 1,
      0
    );

    // 先月と今月の勤怠に差し戻しが存在するかチェック
    const kintaiBscListTwoMonthAgo = Kintai_bscs.filter(
      (p)=>commonFnc.formatDate(p.date) >= commonFnc.formatDate(new Date(dayBeforeMonth)) 
      && commonFnc.formatDate(p.date) <= commonFnc.formatDate(shiftEndDay));
    setIsAlert(kintaiBscListTwoMonthAgo.some((p)=>p.approval_status_cd === "80"));
  },[Kintai_bscs_view]);


  // 表示月切り替え
  const handleButtonClick = (p) =>{
    var d = new Date(shiftStartDay);
    setShiftStartDay(d.setMonth(d.getMonth() + p))
  };

  const getViewMonthStr = () =>{
    
    const date = new Date(shiftStartDay);

    try {
      const y = date.getFullYear();
      const m = date.getMonth()+1;
      return `${y}年${m}月` 
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  
  const moveRequestKintaiPage = ((Kintai_bsc) =>{
    setKintai_bsc(Kintai_bsc);
    // setKintai_bsc({...Kintai_bsc,harf_holiday_shift_type_cd:null});
    localStorage.setItem('mykintai_bsc',JSON.stringify(Kintai_bsc))

    // fechで取得するように変更する
    const query = new URLSearchParams({login_user_id: Kintai_bsc.user_id, date: commonFnc.formatDate(Kintai_bsc.date)});
    fetch(`/api/select/request_overtime?${query}`)
    .then((res) => res.json())
    .then((data) => {
        if(!data || data.length === 0){
            setRequest_overtimes([new Kintai_overtime(Kintai_bsc)])
        }else{
            setRequest_overtimes(data)
        }
    });

    const queryRequest_paid_holiday = new URLSearchParams({login_user_id: Kintai_bsc.user_id, date: commonFnc.formatDate(Kintai_bsc.date)});
    fetch(`/api/select/request_paid_holiday?${queryRequest_paid_holiday}`)
    .then((res) => res.json())
    .then((data) => {
        if(!data){
            setRequest_paid_holiday({
                request_paid_holiday_reason: "",
            })
        }else{
            setRequest_paid_holiday(data)
        }
    });

    let tmp_user = Users.find(item => item.user_id === display_user_info.user_id);
    setDisplay_user_info(tmp_user);

    history.push('/RequestKintai');
})
  

  // 申請ボタンクリック
  const handlerRequestButtonClick = ((target_kintai_bsc) =>{
    const target_shift = Shift_msts.find((p)=>p.shift_type_cd === target_kintai_bsc?.shift_type_cd);
    if(target_kintai_bsc.approval_status_cd === "10" || target_kintai_bsc.approval_status_cd === "80"){
      
        if(commonFnc.formatDate(target_kintai_bsc.date) > commonFnc.formatDate(new Date())){
            const result = window.confirm("未来日の勤務です。本当に申請しますか？");
            if(!result) return;
        }

        if(!target_kintai_bsc.shift_type_cd || (target_shift?.shift_group_cd === shift_group_cd_hash["HARF_WORK_SHIFT_GROUP_CD"] && !target_kintai_bsc.harf_holiday_shift_type_cd)){
            alert("半休シフトが選択されていません。");
            return;
        }
        
        const department_mst = Department_msts.find(p=>p.department_cd === display_user_info.department_cd)
        const first_approval_userid = display_user_info?.first_approval_userid ? display_user_info?.first_approval_userid : department_mst?.first_approval_userid;
        const second_approval_userid = display_user_info?.second_approval_userid ? display_user_info?.second_approval_userid : department_mst?.second_approval_userid;

        // シフト時間が設定されていない場合は勤務時間を入力してください。
        const shift = Shift_msts.find((p)=>p.shift_type_cd === target_kintai_bsc?.shift_type_cd);
        if(!shift.shift_time_from || !shift.shift_time_to
            || shift.clockin_time_from===undefined || shift.clockin_time_to===undefined
            || (shift.clockin_time_from==="00:00" && shift.clockin_time_to==="00:00")){
            BL_kintai.requestApproval(target_kintai_bsc, Department_msts, setKintai_bscs, first_approval_userid, second_approval_userid);
        }else{
            if(!target_kintai_bsc.work_time_from || !target_kintai_bsc.work_time_to ){
                alert("勤務時間を入力してください。");
                return;
            }else{
                BL_kintai.requestApproval(target_kintai_bsc, Department_msts, setKintai_bscs, first_approval_userid, second_approval_userid);
            }
        }
      }
      
      if(target_kintai_bsc.approval_status_cd === "20"
          || (isFirstApprovalUser(target_kintai_bsc) && target_kintai_bsc.approval_status_cd === "30") // 1次承認者の二次待ち 
          || (isSecondApprovalUser(target_kintai_bsc) && target_kintai_bsc.approval_status_cd === "90") // 2次承認者の確定
      ){
          BL_kintai.requestCancel(target_kintai_bsc, Department_msts, setKintai_bscs);
      }
  });

  const isFirstApprovalUser = (kintaiBsc) =>{
      const userid = display_user_info.user_id;
      return kintaiBsc.first_approval_userid === userid
  }

  const isSecondApprovalUser = (kintaiBsc) =>{
      const userid = display_user_info.user_id;
      return kintaiBsc.second_approval_userid === userid
  }

  const style = {
      alertBox: {
          backgroundColor: 'tomato',
          color: 'white',
          padding: '10px',
          borderRadius: '5px',
          fontWeight: 'bold',
          fontSize: '1rem',
          textAlign: 'center',
      }
  }

  return (
    <SPTemplate
      setLogin_user_id={setLogin_user_id}
      setKintai_bscs={setKintai_bscs}
      Login_user_info={Login_user_info}
      setDisplay_user_info={setDisplay_user_info}>
    {isAlert && <Box sx={style.alertBox}> 
        <Typography>前月/今月の勤怠に差し戻しがあります。<br/>勤務を修正してください。</Typography>
    </Box>}
    <Box
      style={styles.calHeader}
    >
      <Button
        style={styles.calHeaderButton}
        onClick={()=>handleButtonClick(-1)}
      >
        <ArrowLeftIcon/>
      </Button>
      <Typography style={styles.calHeaderMonth}>
        {getViewMonthStr()} 
      </Typography>
      <Button
        style={styles.calHeaderButton}
        onClick={()=>handleButtonClick(1)}
      >
        <ArrowRightIcon/>
      </Button>
    </Box>
    <TableContainer
        style={styles.table}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={styles.calcell} stickyHeader>日付</TableCell>
            <TableCell style={styles.calcell} >シフト</TableCell>
            <TableCell style={styles.calcell} >出勤</TableCell>
            <TableCell style={styles.calcell} >退勤</TableCell>
            <TableCell style={styles.calcell} >勤務</TableCell>
            <TableCell style={styles.calcell} >残業</TableCell>
            <TableCell style={styles.calcell} >業外</TableCell>
            {custom1?.log_del_flg ? "" : <TableCell style={styles.calcell} align="center">{custom1?.env_value.substr( 0, 4 )}</TableCell>}
            {custom2?.log_del_flg ? "" : <TableCell style={styles.calcell} align="center">{custom2?.env_value.substr( 0, 4 )}</TableCell>}
            {custom3?.log_del_flg ? "" : <TableCell style={styles.calcell} align="center">{custom3?.env_value.substr( 0, 4 )}</TableCell>}
            {custom4?.log_del_flg ? "" : <TableCell style={styles.calcell} align="center">{custom4?.env_value.substr( 0, 4 )}</TableCell>}
            {custom5?.log_del_flg ? "" : <TableCell style={styles.calcell} align="center">{custom5?.env_value.substr( 0, 4 )}</TableCell>}
            <TableCell style={styles.calcell} >申請</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {
          Kintai_bscs_view.map((Kintai_bsc, index)=>(
            <TableRow key={index} style={{
              backgroundColor: Kintai_bsc.approval_status_cd === '80' ? 'tomato' : commonFnc.getDayofWeekColor(Kintai_bsc.date, holidays)
              }}>
              <TableCell
                style={styles.calcell} 
                scope="row" align="center">
                  <Button variant="outlined" color="primary"
                      onClick={(e)=>moveRequestKintaiPage(Kintai_bsc)}
                      value={commonFnc.ConvertJST(Kintai_bsc.date).split(' ')[0]}
                      style={styles.calButton}>
                      {Kintai_bsc.date.getDate()
                      + "(" + [ "日", "月", "火", "水", "木", "金", "土" ][Kintai_bsc?.date?.getDay()] + ")"}
                  </Button>
              </TableCell>
              <TableCell style={styles.calcell}>
                <Box sx={{display:"flex"}}>
                  <div style={{width:"100%"}}>
                    <div 
                        style={{
                          ...styles.calShift,
                          backgroundColor: Kintai_bsc.shift_type_cd ? shiftColorHash[Kintai_bsc.shift_type_cd]?.backgroundcolor:"transparent" ,
                          color: Kintai_bsc.shift_type_cd ? shiftColorHash[Kintai_bsc.shift_type_cd]?.textcolor:""}}
                        // onClick={()=>handleHolidayShiftEntryButtonClick(Kintai_bsc)}
                        >
                        {shiftHash[Kintai_bsc.shift_type_cd]?shiftHash[Kintai_bsc.shift_type_cd]:"-"}
                    </div>
                    {Kintai_bsc.harf_holiday_shift_type_cd?
                    <div 
                      style={{
                        ...styles.calShift,
                        backgroundColor: Kintai_bsc.harf_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.harf_holiday_shift_type_cd]?.backgroundcolor:"" ,
                        color: Kintai_bsc.harf_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.harf_holiday_shift_type_cd]?.textcolor:""}}>
                        {shiftHash[Kintai_bsc.harf_holiday_shift_type_cd]}
                    </div>
                    :""}
                    {Kintai_bsc.paid_holiday_shift_type_cd?
                    <div
                      className={"shift_type"} 
                      style={{
                        ...styles.calShift,
                        backgroundColor: Kintai_bsc.paid_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.paid_holiday_shift_type_cd]?.backgroundcolor:"" ,
                        color: Kintai_bsc.paid_holiday_shift_type_cd ? shiftColorHash[Kintai_bsc.paid_holiday_shift_type_cd]?.textcolor:""}}>
                        {shiftHash[Kintai_bsc.paid_holiday_shift_type_cd]}
                    </div>
                    :""}
                    </div>
                    {
                        Kintai_bsc.shift_type_cd_change_flg ? <ChangeShiftPriorityHighIcon fontSize='0.7rem'/> :<></>
                    }
                </Box>
              </TableCell>
              <TableCell style={{...styles.calcell, minWidth:isNextDate(Kintai_bsc.date,Kintai_bsc.work_time_from) ? '3rem' : '0'}}>
                {isNextDate(Kintai_bsc.date,Kintai_bsc.work_time_from) ? "翌" : ""}
                <span>{commonFnc.ConvertJSTHHMM(Kintai_bsc.work_time_from)}</span><br/>
                {isNextDate(Kintai_bsc.date,Kintai_bsc.clockin_time_from) ? "翌" : ""}
                <span style={styles.calHelperText}>{(!Kintai_bsc.clockin_time_from ? "" : Kintai_bsc.clockin_time_from)}</span>
              </TableCell>
              <TableCell style={{...styles.calcell, minWidth:isNextDate(Kintai_bsc.date,Kintai_bsc.work_time_to) ? '3rem' : '0'}}>
                {isNextDate(Kintai_bsc.date,Kintai_bsc.work_time_to) ? "翌" : ""}
                <span>{commonFnc.ConvertJSTHHMM(Kintai_bsc.work_time_to)}</span><br/>
                {isNextDate(Kintai_bsc.date,Kintai_bsc.clockin_time_to) ? "翌" : ""}
                <span style={styles.calHelperText}>{(!Kintai_bsc.clockin_time_to ? "" : Kintai_bsc.clockin_time_to)}</span>
              </TableCell>
              <TableCell style={styles.calcell}>
                {!Kintai_bsc.work_time ? "" : commonFnc.getHHmm(Kintai_bsc.work_time)}
              </TableCell>
              <TableCell style={styles.calcell}>
                {!Kintai_bsc.over_time ? "" : commonFnc.getHHmm(Kintai_bsc.over_time)}
              </TableCell>
              <TableCell style={styles.calcell}>
                {!Kintai_bsc.training_time ? "" : commonFnc.getHHmm(Kintai_bsc.training_time)}
              </TableCell>
              {custom1?.log_del_flg ? "" : <TableCell  style={styles.calcell} >{Kintai_bsc.custom1 ? commonFnc.getHHmm(Kintai_bsc.custom1) : ""}</TableCell>}
              {custom2?.log_del_flg ? "" : <TableCell  style={styles.calcell} >{Kintai_bsc.custom2 ? commonFnc.getHHmm(Kintai_bsc.custom2) : ""}</TableCell>}
              {custom3?.log_del_flg ? "" : <TableCell  style={styles.calcell} >{Kintai_bsc.custom3 ? commonFnc.getHHmm(Kintai_bsc.custom3) : ""}</TableCell>}
              {custom4?.log_del_flg ? "" : <TableCell  style={styles.calcell} >{Kintai_bsc.custom4 ? commonFnc.getHHmm(Kintai_bsc.custom4) : ""}</TableCell>}
              {custom5?.log_del_flg ? "" : <TableCell  style={styles.calcell} >{Kintai_bsc.custom5 ? commonFnc.getHHmm(Kintai_bsc.custom5) : ""}</TableCell>}
              <TableCell style={styles.calcell}>
                <Button variant="outlined" color="primary"
                    disabled={Kintai_bsc.approval_status_cd !== "10" && Kintai_bsc.approval_status_cd !== "20" && Kintai_bsc.approval_status_cd !== "80"}
                    onClick={(e)=>handlerRequestButtonClick(Kintai_bsc)}
                    style={
                      (Kintai_bsc.approval_status_cd === "10" || Kintai_bsc.approval_status_cd === "80" )?
                         styles.calButton : 
                         Kintai_bsc.approval_status_cd === "20"? 
                          {...styles.calButton, ...styles.calButtonCancel} : 
                          {...styles.calButton, ...styles.calButtonDisabled}
                      }>
                    {(Kintai_bsc.approval_status_cd === "10" || Kintai_bsc.approval_status_cd === "80" )? "申請" : "取消"}
                </Button>
              </TableCell>
            </TableRow>
          ))
        }
        
        </TableBody>
      </Table>
    </TableContainer>
        
      
    </SPTemplate>
  );
}

export default SP_KintaiListPage;